export default __webpack_public_path__ + "static/media/linkedin.b14830b7.svg";